<template>

  <div class="pl-1 fill-height" :class="{'font-italic': isException}">

    <template v-if="calendarType === 'month'">

      <v-icon v-if="icon" :icon="icon" :color="iconColor" />
      {{ title }}

    </template>

    <template v-if="calendarType === 'day'">

      <div class="d-flex justify-space-between">
        <div class="text-wrap">{{ title }}</div>
        <v-icon v-if="icon" :icon="icon" :color="iconColor" />
      </div>

      <div v-if="$slots.extras" class="mt-4 text-wrap">
        <slot name="extras" />
      </div>

    </template>

  </div>

</template>

<script setup lang="ts">

interface Props {
  title: string
  calendarType: string
  isException?: boolean
  icon?: null | string
  iconColor?: string
}

withDefaults(defineProps<Props>(), {
  isException: false,
  icon: null,
})

</script>
